import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Form from "./Form";


const Edit = ({id}) => {


    const [user, setUser] = useState()
    const [errors, setErrors] = useState()
    const [roles, setRoles] = useState([])
    const [accounts, setAccounts] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    const GetEntities = async () => {
        const requestUser = await UsePut(
            `/users/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        const requestAccounts = await UsePut(
            `/accounts/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )

        const requestRoles = await UsePut(
            `/roles/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )

        return {
            user    : requestUser?.entities[0],
            roles   : requestRoles,
            accounts: requestAccounts
        }
    }


    useEffect(() => {
        GetEntities().then((response) => {
            setUser(response.user)
            setRoles(response.roles)
            setAccounts(response.accounts)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/users/upsert/${id}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'User has been successfully updated')
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form user={user} roles={roles} accounts={accounts} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit